import React from 'react';

import {cls} from '../../utils';

import css from './progress.module.css';

export type ProgressColor = 'brand' | 'success' | 'warning' | 'error';

type Props = {
	label?: string;
	helperText?: string;
	percentComplete?: number | null;
	/** цвет полосы: состояние, которое она показывает */
	color?: ProgressColor;
	className?: string;
};

export const Progress: React.FC<Props> = ({percentComplete, label, helperText, color = 'brand', className}) => {
	return (
		<div className={cls(css[color], className)}>
			{label && <div className={css.label}>{label}</div>}
			<div className={css.progress}>
				<div className={css.track} />
				<div className={css.bar} />
				{percentComplete !== null && percentComplete !== undefined ? (
					<div
						className={css.bar}
						role="progressbar"
						aria-valuemin={0}
						aria-valuemax={100}
						aria-valuenow={percentComplete}
						style={{width: `${percentComplete}%`}}
					/>
				) : (
					<div className={cls(css.bar, css.indeterminate)} role="progressbar" />
				)}
			</div>
			{helperText && <div className={css.note}>{helperText}</div>}
		</div>
	);
};
